import React, { useState } from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import WageCost from './WageCost';
import DeminimisRegulation from './DeminimisRegulation';
import Affiliates from './Affiliates';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import FurtherRequirements from './FurtherRequirements';
import PowerOfAttorney from './PowerOfAttorney';
import Partnerships from './Partnerships';
const GeneralCompanyInformation = _ref => {
  let {
    financialYear,
    wageCosts,
    setWageCosts,
    affiliates,
    setAffiliates,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const history = useHistory();
  const subTab1 = new URLSearchParams(search).get('sub_tab1');
  const goToTab = key => {
    history.push({
      search: "?main_tab=general_company_information&sub_tab1=".concat(key)
    });
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: goToTab,
    activeKey: subTab1,
    className: "mb-3 ms-3",
    defaultActiveKey: 'affiliates'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "affiliates",
    title: t('affiliates')
  }, /*#__PURE__*/React.createElement(Affiliates, {
    affiliates: affiliates,
    setAffiliates: setAffiliates,
    financialYear: financialYear,
    elsterId: elster.id,
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "partnerships",
    title: t('partnerships')
  }, subTab1 === 'partnerships' && /*#__PURE__*/React.createElement(Partnerships, {
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "wage_costs",
    title: t('wage_costs')
  }, /*#__PURE__*/React.createElement(WageCost, {
    financialYear: financialYear,
    wageCosts: wageCosts,
    setWageCosts: setWageCosts,
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "deminimis_regulation",
    title: t('deminimis_regulation')
  }, subTab1 === 'deminimis_regulation' && /*#__PURE__*/React.createElement(DeminimisRegulation, {
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "further_requirements",
    title: t('further_requirements')
  }, subTab1 === 'further_requirements' && /*#__PURE__*/React.createElement(FurtherRequirements, {
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "power_of_attorney",
    title: t('power_of_attorney')
  }, subTab1 === 'power_of_attorney' && /*#__PURE__*/React.createElement(PowerOfAttorney, {
    elster: elster
  })))));
};
export default GeneralCompanyInformation;